/**
 * Cemwall — Process Canvas + Step Navigation
 * Extracted from preview HTML and adapted for Shopify.
 * Reads step labels from window.CEMWALL_STEP_LABELS if present.
 */
document.addEventListener('DOMContentLoaded', () => {
  initProcessCanvas();
});

function initProcessCanvas() {
  const canvas = document.getElementById('processCanvas');
  if (!canvas) return;

  // Use labels from Liquid-rendered JSON if available, otherwise fallback
  const LABELS = (window.CEMWALL_STEP_LABELS && window.CEMWALL_STEP_LABELS.length === 8)
    ? window.CEMWALL_STEP_LABELS
    : [
        'Se vacía la cimentación de concreto reforzado. Las varillas de arranque quedan expuestas hacia arriba para anclar los paneles.',
        'Los paneles de fibrocemento —ya con el sistema de copas integrado— se colocan a ambos lados de las varillas, formando el molde permanente del muro.',
        'La varilla vertical de refuerzo se inserta a través de las copas, atravesando todo el muro y conectando ambas caras.',
        'Se instalan puntales diagonales temporales en ambos lados para garantizar la verticalidad del muro durante el colado.',
        'Se vierte el concreto de alta resistencia desde la parte superior, llenando por completo la cavidad entre los dos paneles.',
        'El concreto cura dentro del encofrado permanente. El tono cambia de húmedo a curado conforme alcanza su resistencia.',
        'Una vez curado el concreto, se retiran los puntales diagonales: el muro ya es autoportante.',
        'Muro terminado: una estructura monolítica de concreto reforzado con acabado de fibrocemento en ambas caras, lista para recibir acabados.'
      ];

  const CL = {
    bg1:'#f2f0ed', bg2:'#fbfaf8',
    ground1:'#cfc9c0', ground2:'#b9b2a6', ground3:'#a39c8e',
    footingFace:'#d9d5cf', footingSide:'#b8b3aa', footingTop:'#ece8e3',
    rebar:'#9a9a9a', rebarHi:'#c8c8c8', rebarVert:'#fe3a00', rebarVertHi:'#ff7a4d',
    panelFaceL:'#eae6e0', panelFaceR:'#e2ddd6', panelSide:'#c8c4be', panelTop:'#f4f1ec',
    cup:'#fe3a00', cupDark:'#c22e00',
    brace:'#c4c0ba', braceDark:'#9c9890', braceAccent:'#fe3a00',
    wet:'#8d8a84', cured:'#d6d2cb',
    accent:'#fe3a00'
  };

  const ctx = canvas.getContext('2d');
  let dpr = 1, SW, SH;
  const W = 900, H = 500;

  let targetStep = 0, currentStep = 0, running = false, raf = null;

  const sectionEl = document.getElementById('proceso');
  const stepBtns  = document.querySelectorAll('.step-btn');
  const labelEl   = document.getElementById('processLabel');

  // Support per-button label override via data-label attribute
  stepBtns.forEach((btn, i) => {
    if (!btn.dataset.label && LABELS[i]) btn.dataset.label = LABELS[i];
  });

  function resizeCanvas() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    const wrap = canvas.parentElement;
    // Use inner width (subtract padding) so canvas never overflows
    const style = window.getComputedStyle(wrap);
    const padL  = parseFloat(style.paddingLeft)  || 0;
    const padR  = parseFloat(style.paddingRight) || 0;
    SW = Math.floor(wrap.clientWidth - padL - padR);
    SH = Math.round(SW * (H / W));
    canvas.width  = SW * dpr; canvas.height = SH * dpr;
    canvas.style.width  = SW + 'px'; canvas.style.height = SH + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    draw(currentStep);
  }

  function sc(v) { return v * (SW / W); }
  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function cMix(a, b, t) {
    const hx = s => parseInt(s, 16);
    const r  = Math.round(hx(a.slice(1,3)) + (hx(b.slice(1,3)) - hx(a.slice(1,3))) * t);
    const g  = Math.round(hx(a.slice(3,5)) + (hx(b.slice(3,5)) - hx(a.slice(3,5))) * t);
    const bl = Math.round(hx(a.slice(5,7)) + (hx(b.slice(5,7)) - hx(a.slice(5,7))) * t);
    return `rgb(${r},${g},${bl})`;
  }

  const WALL_CX = 450, WALL_W = 200, PANEL_T = 16;
  const WALL_TOP = 90, WALL_BOT = 380, FOOTING_H = 30, ISO = 14;
  const leftPanelX  = WALL_CX - WALL_W / 2 - PANEL_T;
  const rightPanelX = WALL_CX + WALL_W / 2;
  const coreX = WALL_CX - WALL_W / 2, coreW = WALL_W;
  const rebarStartXs = [WALL_CX - 50, WALL_CX + 50];

  function drawBackground() {
    const g = ctx.createLinearGradient(0, 0, 0, sc(H));
    g.addColorStop(0, CL.bg1); g.addColorStop(1, CL.bg2);
    ctx.fillStyle = g; ctx.fillRect(0, 0, sc(W), sc(H));
    ctx.save();
    ctx.strokeStyle = 'rgba(0,0,0,0.025)'; ctx.lineWidth = 1;
    for (let x = 0; x <= W; x += 60) {
      ctx.beginPath(); ctx.moveTo(sc(x), sc(WALL_BOT + FOOTING_H)); ctx.lineTo(sc(x * 0.5 + 225), sc(H)); ctx.stroke();
    }
    ctx.restore();
  }

  function drawFooting(t) {
    const fw = sc(280), fh = sc(FOOTING_H) * t;
    const x = sc(WALL_CX) - fw / 2, y = sc(WALL_BOT) - fh;
    ctx.save();
    ctx.fillStyle = 'rgba(0,0,0,0.06)';
    ctx.beginPath(); ctx.ellipse(x + fw/2, sc(WALL_BOT) + sc(8), fw*0.56, sc(10), 0, 0, Math.PI*2); ctx.fill();
    ctx.fillStyle = CL.footingFace; ctx.fillRect(x, y, fw, fh);
    const id = sc(ISO) * t;
    ctx.fillStyle = CL.footingTop;
    ctx.beginPath(); ctx.moveTo(x,y); ctx.lineTo(x+id, y-id*0.5); ctx.lineTo(x+fw+id, y-id*0.5); ctx.lineTo(x+fw,y); ctx.closePath(); ctx.fill();
    ctx.fillStyle = CL.footingSide;
    ctx.beginPath(); ctx.moveTo(x+fw,y); ctx.lineTo(x+fw+id, y-id*0.5); ctx.lineTo(x+fw+id, y-id*0.5+fh); ctx.lineTo(x+fw,y+fh); ctx.closePath(); ctx.fill();
    if (t > 0.5) {
      const da = Math.min((t-0.5)/0.5, 1);
      ctx.globalAlpha = da * 0.55; ctx.fillStyle = CL.rebar;
      const dotR = sc(2.8), topY = y + fh*0.28, botY2 = y + fh*0.72, sp = fw/5;
      for (let i = 1; i <= 4; i++) {
        const dx = x + sp*i;
        ctx.beginPath(); ctx.arc(dx, topY, dotR, 0, Math.PI*2); ctx.fill();
        ctx.beginPath(); ctx.arc(dx, botY2, dotR, 0, Math.PI*2); ctx.fill();
      }
      ctx.globalAlpha = 1;
    }
    ctx.restore();
  }

  function drawRebarStubs(t) {
    const baseY = sc(WALL_BOT) - sc(FOOTING_H), stubH = sc(34) * t;
    rebarStartXs.forEach(rx => {
      const x = sc(rx), y = baseY - stubH;
      const grad = ctx.createLinearGradient(x-2, 0, x+2, 0);
      grad.addColorStop(0, CL.rebar); grad.addColorStop(0.5, CL.rebarHi); grad.addColorStop(1, CL.rebar);
      ctx.fillStyle = grad; ctx.fillRect(x - sc(2), y, sc(4), stubH);
      ctx.beginPath(); ctx.arc(x, y, sc(2.5), 0, Math.PI*2); ctx.fillStyle = CL.rebarHi; ctx.fill();
    });
  }

  function drawPanel(side, t) {
    if (t <= 0) return;
    const e = easeOut(t), slideDist = 140;
    const px = side === 'left' ? leftPanelX : rightPanelX;
    const targetY = WALL_TOP, py = targetY - slideDist * (1 - e);
    const pw = PANEL_T, ph = WALL_BOT - FOOTING_H - WALL_TOP;
    const sx = sc(px), sy = sc(py), sw = sc(pw), sh = sc(ph), id = sc(ISO);
    ctx.save();
    ctx.globalAlpha = e;
    ctx.shadowColor = 'rgba(0,0,0,0.10)'; ctx.shadowBlur = sc(14);
    ctx.shadowOffsetX = side==='left' ? -sc(4) : sc(4); ctx.shadowOffsetY = sc(6);
    ctx.fillStyle = side==='left' ? CL.panelFaceL : CL.panelFaceR;
    ctx.fillRect(sx, sy, sw, sh);
    ctx.shadowBlur = 0; ctx.shadowOffsetX = 0; ctx.shadowOffsetY = 0;
    ctx.fillStyle = CL.panelSide;
    if (side === 'left') {
      ctx.beginPath(); ctx.moveTo(sx,sy); ctx.lineTo(sx-id,sy-id*0.5); ctx.lineTo(sx-id,sy+sh-id*0.5); ctx.lineTo(sx,sy+sh); ctx.closePath(); ctx.fill();
    } else {
      ctx.beginPath(); ctx.moveTo(sx+sw,sy); ctx.lineTo(sx+sw+id,sy-id*0.5); ctx.lineTo(sx+sw+id,sy+sh-id*0.5); ctx.lineTo(sx+sw,sy+sh); ctx.closePath(); ctx.fill();
    }
    ctx.fillStyle = CL.panelTop;
    if (side === 'left') {
      ctx.beginPath(); ctx.moveTo(sx,sy); ctx.lineTo(sx-id,sy-id*0.5); ctx.lineTo(sx+sw-id,sy-id*0.5); ctx.lineTo(sx+sw,sy); ctx.closePath(); ctx.fill();
    } else {
      ctx.beginPath(); ctx.moveTo(sx,sy); ctx.lineTo(sx+id,sy-id*0.5); ctx.lineTo(sx+sw+id,sy-id*0.5); ctx.lineTo(sx+sw,sy); ctx.closePath(); ctx.fill();
    }
    ctx.strokeStyle = 'rgba(0,0,0,0.06)'; ctx.lineWidth = 1;
    for (let f=1;f<=3;f++) { const ly=sy+sh*(f/4); ctx.beginPath(); ctx.moveTo(sx,ly); ctx.lineTo(sx+sw,ly); ctx.stroke(); }
    [0.18, 0.40, 0.62, 0.84].forEach(f => {
      const cy=sy+sh*f, cupW=sc(13), cupH=sc(8);
      const cx = side==='left' ? sx+sw-cupW*0.3 : sx-cupW*0.7;
      ctx.fillStyle = CL.cup;
      ctx.beginPath();
      ctx.roundRect ? ctx.roundRect(cx,cy-cupH/2,cupW,cupH,sc(2)) : ctx.rect(cx,cy-cupH/2,cupW,cupH);
      ctx.fill();
      ctx.fillStyle = 'rgba(0,0,0,0.22)';
      ctx.fillRect(cx+cupW*0.25,cy-cupH*0.18,cupW*0.5,cupH*0.36);
    });
    ctx.restore();
  }

  function drawVerticalRebar(t) {
    if (t<=0) return;
    const e=easeOut(t), topY=WALL_TOP-14, botY=WALL_BOT-FOOTING_H+6, fullH=botY-topY;
    rebarStartXs.forEach((rx,i) => {
      const delay=i*0.15, rt=clamp((e-delay)/(1-delay),0,1);
      if (rt<=0) return;
      const h=fullH*rt, x=sc(rx), y=sc(topY);
      const grad=ctx.createLinearGradient(x-sc(3),0,x+sc(3),0);
      grad.addColorStop(0,CL.rebarVertHi); grad.addColorStop(0.5,CL.rebarVert); grad.addColorStop(1,CL.rebarVertHi);
      ctx.fillStyle=grad; ctx.fillRect(x-sc(2.5),y,sc(5),sc(h));
      ctx.beginPath(); ctx.arc(x,y,sc(4),0,Math.PI*2); ctx.fillStyle=CL.rebarVertHi; ctx.fill();
      if (rt>0.95) {
        [0.18,0.40,0.62,0.84].forEach(f => {
          const ty=sc(topY+fullH*f);
          ctx.fillStyle=CL.rebarVert; ctx.beginPath(); ctx.arc(x,ty,sc(3.5),0,Math.PI*2); ctx.fill();
          ctx.fillStyle=CL.rebarVertHi; ctx.beginPath(); ctx.arc(x,ty,sc(2),0,Math.PI*2); ctx.fill();
        });
      }
    });
  }

  function drawBrace(x1,y1,x2,y2,t) {
    if (t<=0) return;
    const ex=lerp(x1,x2,t), ey=lerp(y1,y2,t);
    const dx=ex-x1, dy=ey-y1, len=Math.sqrt(dx*dx+dy*dy)||1;
    const nx=-dy/len*sc(2.5), ny=dx/len*sc(2.5);
    ctx.save();
    ctx.fillStyle='rgba(0,0,0,0.07)';
    ctx.beginPath(); ctx.moveTo(x1+nx+sc(3),y1+ny+sc(3)); ctx.lineTo(ex+nx+sc(3),ey+ny+sc(3)); ctx.lineTo(ex-nx+sc(3),ey-ny+sc(3)); ctx.lineTo(x1-nx+sc(3),y1-ny+sc(3)); ctx.closePath(); ctx.fill();
    const grad=ctx.createLinearGradient(x1,y1,ex,ey);
    grad.addColorStop(0,CL.brace); grad.addColorStop(1,CL.braceDark);
    ctx.fillStyle=grad;
    ctx.beginPath(); ctx.moveTo(x1+nx,y1+ny); ctx.lineTo(ex+nx,ey+ny); ctx.lineTo(ex-nx,ey-ny); ctx.lineTo(x1-nx,y1-ny); ctx.closePath(); ctx.fill();
    ctx.strokeStyle=CL.braceAccent; ctx.lineWidth=sc(1.5); ctx.globalAlpha=0.6;
    ctx.beginPath(); ctx.moveTo(x1,y1); ctx.lineTo(ex,ey); ctx.stroke();
    ctx.globalAlpha=1;
    [{x:x1,y:y1},{x:ex,y:ey}].forEach(p => {
      ctx.beginPath(); ctx.ellipse(p.x,p.y,sc(7),sc(3),0,0,Math.PI*2); ctx.fillStyle=CL.braceDark; ctx.fill();
    });
    ctx.restore();
  }

  function drawBraces(t) {
    drawBrace(sc(leftPanelX-2),sc(WALL_TOP+30),sc(leftPanelX-75),sc(WALL_BOT-FOOTING_H+4),t);
    drawBrace(sc(rightPanelX+PANEL_T+2),sc(WALL_TOP+50),sc(rightPanelX+PANEL_T+75),sc(WALL_BOT-FOOTING_H+4),t);
  }

  const particles = [];
  function drawConcrete(fillT, cureT) {
    if (fillT<=0) return;
    const e=easeOut(fillT);
    const cx=sc(coreX), cw=sc(coreW);
    const topY=sc(WALL_TOP-6), botY=sc(WALL_BOT-FOOTING_H);
    const h=(botY-topY)*e, y=botY-h;
    const top=cMix(CL.wet,CL.cured,cureT), bot=cMix(CL.wet,CL.cured,cureT*0.85);
    ctx.save();
    ctx.beginPath(); ctx.rect(cx,topY,cw,botY-topY+sc(6)); ctx.clip();
    const g=ctx.createLinearGradient(cx,y,cx,botY);
    g.addColorStop(0,top); g.addColorStop(1,bot);
    ctx.fillStyle=g; ctx.fillRect(cx-sc(10),y,cw+sc(20),botY-y+sc(20));
    if (cureT<0.4 && fillT<1) { ctx.fillStyle=`rgba(255,255,255,${(1-cureT)*0.18})`; ctx.fillRect(cx+sc(4),y,cw-sc(8),sc(3)); }
    rebarStartXs.forEach(rx => {
      ctx.fillStyle=`rgba(60,30,20,${0.10+cureT*0.05})`;
      ctx.fillRect(sc(rx)-sc(2),topY,sc(4),botY-topY);
    });
    ctx.restore();
    if (fillT < 0.97) {
      const nozzleY=sc(WALL_TOP-50), streamX=sc(WALL_CX)+Math.sin(Date.now()*0.006)*sc(3);
      ctx.fillStyle='#777'; ctx.fillRect(streamX-sc(16),nozzleY-sc(12),sc(32),sc(16));
      ctx.fillStyle='#999'; ctx.fillRect(streamX-sc(16),nozzleY-sc(12),sc(32),sc(4));
      ctx.strokeStyle='rgba(141,138,132,0.85)'; ctx.lineWidth=sc(7); ctx.lineCap='round';
      ctx.beginPath(); ctx.moveTo(streamX,nozzleY+sc(4)); ctx.lineTo(streamX,y+sc(4)); ctx.stroke();
      if (particles.length<50 && Math.random()<0.7) {
        for (let j=0;j<2;j++) particles.push({x:WALL_CX+(Math.random()-0.5)*(coreW-16),y:WALL_TOP-4,vy:1.4+Math.random()*2.2,r:1+Math.random()*1.4,alpha:0.5+Math.random()*0.3});
      }
    }
    for (let i=particles.length-1;i>=0;i--) {
      const p=particles[i]; p.y+=p.vy; p.alpha-=0.012;
      if (p.alpha<=0||sc(p.y)>y+h) { particles.splice(i,1); continue; }
      ctx.globalAlpha=p.alpha; ctx.fillStyle='#cfc9c2';
      ctx.beginPath(); ctx.arc(sc(p.x),sc(p.y),sc(p.r),0,Math.PI*2); ctx.fill();
    }
    ctx.globalAlpha=1;
  }

  function drawCureIndicator(cureT) {
    if (cureT<=0) return;
    const days=Math.round(cureT*28), cx=sc(WALL_CX), y=sc(WALL_TOP-36);
    ctx.save();
    ctx.font=`${Math.round(sc(12))}px Inter, sans-serif`;
    ctx.fillStyle='rgba(0,0,0,0.45)'; ctx.textAlign='center';
    ctx.fillText(`Curado · ${days} días`,cx,y);
    const barW=sc(120),barH=sc(3),bx=cx-barW/2,by=y+sc(8);
    ctx.fillStyle='rgba(0,0,0,0.08)'; ctx.fillRect(bx,by,barW,barH);
    ctx.fillStyle=CL.accent; ctx.fillRect(bx,by,barW*cureT,barH);
    ctx.restore();
  }

  function drawFinalHighlight(t) {
    if (t<=0) return;
    const e=easeOut(t);
    ctx.save(); ctx.globalAlpha=e;
    const gx=sc(WALL_CX),gy=sc((WALL_TOP+WALL_BOT-FOOTING_H)/2);
    const grad=ctx.createRadialGradient(gx,gy,sc(20),gx,gy,sc(180));
    grad.addColorStop(0,'rgba(254,58,0,0.08)'); grad.addColorStop(1,'rgba(254,58,0,0)');
    ctx.fillStyle=grad; ctx.fillRect(gx-sc(200),gy-sc(220),sc(400),sc(440));
    const lx=sc(rightPanelX+PANEL_T+90);
    ctx.strokeStyle='rgba(0,0,0,0.18)'; ctx.lineWidth=1; ctx.setLineDash([4,4]);
    ctx.beginPath();
    ctx.moveTo(sc(rightPanelX+PANEL_T+4),sc(WALL_TOP)); ctx.lineTo(lx,sc(WALL_TOP));
    ctx.moveTo(sc(rightPanelX+PANEL_T+4),sc(WALL_BOT-FOOTING_H)); ctx.lineTo(lx,sc(WALL_BOT-FOOTING_H));
    ctx.moveTo(lx,sc(WALL_TOP)); ctx.lineTo(lx,sc(WALL_BOT-FOOTING_H));
    ctx.stroke(); ctx.setLineDash([]);
    const bw=sc(132),bh=sc(28),bx=lx+sc(10),by=sc((WALL_TOP+WALL_BOT-FOOTING_H)/2-14);
    ctx.fillStyle='rgba(255,255,255,0.95)'; ctx.strokeStyle='rgba(0,0,0,0.1)'; ctx.lineWidth=1;
    ctx.beginPath();
    ctx.roundRect ? ctx.roundRect(bx,by,bw,bh,sc(4)) : ctx.rect(bx,by,bw,bh);
    ctx.fill(); ctx.stroke();
    ctx.fillStyle='#1a1a1a'; ctx.font=`600 ${Math.round(sc(11))}px Inter, sans-serif`;
    ctx.textAlign='center'; ctx.textBaseline='middle';
    ctx.fillText('MURO TERMINADO',bx+bw/2,by+bh/2);
    ctx.restore();
  }

  function draw(stepVal) {
    ctx.clearRect(0, 0, SW * dpr, SH * dpr);
    drawBackground();
    const v = Math.max(0, stepVal);
    drawFooting(1);
    drawRebarStubs(1);
    const panelT = easeOut(clamp(v-0,0,1));
    if (panelT>0) { drawPanel('left',panelT); drawPanel('right',panelT); }
    const rebarT = easeOut(clamp(v-1,0,1));
    if (rebarT>0) drawVerticalRebar(rebarT);
    let braceT = easeOut(clamp(v-2,0,1));
    if (v>5) braceT = easeOut(clamp(1-(v-5),0,1));
    if (braceT>0) drawBraces(braceT);
    const pourT = easeOut(clamp(v-3,0,1));
    const cureT = easeOut(clamp(v-4,0,1));
    if (pourT>0) { drawConcrete(pourT,cureT); if (cureT>0) drawCureIndicator(cureT); }
    const finalT = easeOut(clamp(v-6,0,1));
    if (finalT>0) drawFinalHighlight(finalT);
    ctx.save();
    ctx.strokeStyle='rgba(0,0,0,0.08)'; ctx.lineWidth=1;
    ctx.beginPath();
    ctx.moveTo(sc(WALL_CX)-sc(160),sc(WALL_BOT)+sc(2)); ctx.lineTo(sc(WALL_CX)+sc(160),sc(WALL_BOT)+sc(2)); ctx.stroke();
    ctx.restore();
  }

  function setActiveStep(idx) {
    stepBtns.forEach((b,i) => b.classList.toggle('active', i===idx));
    if (labelEl) labelEl.textContent = (stepBtns[idx] && stepBtns[idx].dataset.label) || LABELS[idx] || '';
    // Scroll active button into view on mobile nav
    const activeBtn = stepBtns[idx];
    if (activeBtn && activeBtn.parentElement) {
      const nav = activeBtn.parentElement;
      const btnLeft   = activeBtn.offsetLeft;
      const btnWidth  = activeBtn.offsetWidth;
      const navWidth  = nav.offsetWidth;
      const target    = btnLeft - navWidth / 2 + btnWidth / 2;
      nav.scrollTo({ left: target, behavior: 'smooth' });
    }
  }

  function goToStep(idx) {
    idx = clamp(idx, 0, 7);
    if (idx===targetStep && !running) return;
    targetStep=idx; setActiveStep(idx);
    animFrom=currentStep; animTo=targetStep; animStart=null;
    if (!running) { running=true; raf=requestAnimationFrame(tick); }
  }

  let animFrom=0, animTo=0, animStart=null;
  const ANIM_MS=900;

  function tick(ts) {
    if (animStart===null) animStart=ts;
    const elapsed=ts-animStart, t=clamp(elapsed/ANIM_MS,0,1), e=easeOut(t);
    currentStep=animFrom+(animTo-animFrom)*e;
    draw(currentStep);
    const settled=t>=1;
    if (settled) currentStep=animTo;
    if (!settled || particles.length>0) { raf=requestAnimationFrame(tick); }
    else { running=false; raf=null; }
  }

  // Button click
  stepBtns.forEach(btn => {
    btn.addEventListener('click', () => goToStep(parseInt(btn.dataset.step, 10)));
  });

  // Touch swipe on canvas → advance/rewind steps
  let touchStartX = null, touchStartY = null;
  canvas.addEventListener('touchstart', e => {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });
  canvas.addEventListener('touchend', e => {
    if (touchStartX === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX;
    const dy = e.changedTouches[0].clientY - touchStartY;
    // Only trigger if horizontal swipe dominates
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
      goToStep(targetStep + (dx < 0 ? 1 : -1));
    }
    touchStartX = null; touchStartY = null;
  }, { passive: true });

  // Keyboard arrows
  document.addEventListener('keydown', e => {
    if (!sectionEl) return;
    const rect = sectionEl.getBoundingClientRect();
    if (rect.top > window.innerHeight || rect.bottom < 0) return;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); goToStep(targetStep + 1); }
    if (e.key === 'ArrowLeft'  || e.key === 'ArrowUp')   { e.preventDefault(); goToStep(targetStep - 1); }
  });

  resizeCanvas();
  // Resize on window resize AND orientation change
  window.addEventListener('resize', resizeCanvas);
  window.addEventListener('orientationchange', () => setTimeout(resizeCanvas, 150));
  setActiveStep(0);
  draw(0);

  if (!sectionEl) return;
  let autoStarted=false;
  new IntersectionObserver(entries => {
    if (entries[0].isIntersecting && !autoStarted) {
      autoStarted=true;
      let i=0;
      const playNext=() => { if (i>7) return; goToStep(i); i++; if (i<=7) setTimeout(playNext, 1900); };
      setTimeout(playNext, 500);
    }
  }, { threshold: 0.35 }).observe(sectionEl);
}
